import request from '@/config/axios'

export interface HomeBannerVO {
  id?: number
  title: string
  subtitle?: string
  cta?: string
  link?: string
  picUrl?: string
  /** 详情正文：无外链时 H5 打开站内详情页展示 */
  content?: string
  sort: number
  status: number
  createTime?: string
}

export interface HomeBannerPageReqVO {
  pageNo?: number
  pageSize?: number
  title?: string
  status?: number
}

export const HomeBannerApi = {
  getPage: async (params: HomeBannerPageReqVO) => {
    return await request.get({ url: '/lawyer/home-banner/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/lawyer/home-banner/get', params: { id } })
  },
  create: async (data: HomeBannerVO) => {
    return await request.post({ url: '/lawyer/home-banner/create', data })
  },
  update: async (data: HomeBannerVO) => {
    return await request.put({ url: '/lawyer/home-banner/update', data })
  },
  updateStatus: async (id: number, status: number) => {
    return await request.put({ url: '/lawyer/home-banner/update-status', params: { id, status } })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/lawyer/home-banner/delete', params: { id } })
  }
}
